import { render, staticRenderFns } from "./code-editor.vue?vue&type=template&id=0070dcef&scoped=true&"
import script from "./code-editor.js?vue&type=script&lang=js&"
export * from "./code-editor.js?vue&type=script&lang=js&"
import style0 from "./code-editor.scss?vue&type=style&index=0&id=0070dcef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070dcef",
  null
  
)

component.options.__file = "code-editor.vue"
export default component.exports